import React from 'react'
import { Link } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'
import teamStyle from 'assets/jss/material-kit-react/views/landingPageSections/teamStyle.jsx'
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'

const ErrorContent = ({ classes }) => (
    <GridContainer justify="center">
        <GridItem md={12}>
            <span>
                <h4 className={classes.description}>
          We track this kind of thing so we can prevent it to the future. But,
          because we don't really know where you were trying to go, best we can
          do is take you to the <Link to="/">Homepage</Link>
                </h4>
            </span>
        </GridItem>
    </GridContainer>
)

export default withStyles(teamStyle)(ErrorContent)



// WEBPACK FOOTER //
// ./src/views/ErrorPage/ErrorContent.jsx